import { render } from "./GProductosView.vue?vue&type=template&id=1ede9192"
import script from "./GProductosView.vue?vue&type=script&lang=js"
export * from "./GProductosView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__